.divider {
  margin-top: var(--tuna-spacing-4);
  margin-bottom: var(--tuna-spacing-4);
}

.gridContainer {
  min-height: 200px;
}

.notesHeading {
  margin-top: var(--tuna-spacing-2);
}

.noteChip {
  margin: var(--tuna-spacing-1);
}

.altNamesHeading {
  margin-top: var(--tuna-spacing-2);
}

.altNameLink {
  padding-right: var(--tuna-spacing-1);
}
